export enum Errors {
    MandatoryFieldError = 'aumico_annual_report_mandatory_field_error',
    Balance_Sheet_Date_Error = 'aumico_annual_report_general_information_balance_sheet_date_error',
    Balance_Previous_Sheet_Date_Error = 'aumico_annual_report_general_information_previous_sheet_date_error',
    Income_Current_Date_From_Error = 'aumico_annual_report_general_information_income_current_date_from_error',
    Income_Current_Date_To_Error = 'aumico_annual_report_general_information_income_current_date_to_error',
    Income_Previous_Date_From_Error = 'aumico_annual_report_general_information_income_previous_date_from_error',
    Income_Previous_Date_To_Error = 'aumico_annual_report_general_information_income_previous_date_to_error',
    Not_Found = 'aumico_annual_report_not_found_error',
    ServerError = 'aumico_errors_server_error',
}
